import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

@Injectable({
    providedIn: 'root'
})
export class TokenStorageService {

    private jwtHelper = new JwtHelperService();

    signOut(): void {
        const langCode = localStorage.getItem('languageCode');
        window.localStorage.clear();
        if (langCode) {
            localStorage.setItem('languageCode', langCode);
        }
    }

    public saveToken(token: string): void {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.setItem(TOKEN_KEY, token);
    }

    public getToken(): string {
        return localStorage.getItem(TOKEN_KEY);
    }

    public saveUser(user): void {
        window.localStorage.removeItem(USER_KEY);
        window.localStorage.setItem(USER_KEY, JSON.stringify(user));
    }

    public getUser(): any {
        return JSON.parse(localStorage.getItem(USER_KEY));
    }

    public hasTokenExpired(): boolean {
        if (!this.getToken()) {
            return true;
        }
        return this.jwtHelper.isTokenExpired(this.getToken());
    }
}
